



































































































































































































































































































/* General */
import Vue from 'vue'
import { cloneDeep } from 'lodash'

/* Mixins */

/* Components */
import ConversationDetailLoading from './conversation-detail-loading.vue'
import ConversationDetailHeaderMessage from './conversation-detail-header-message.vue'
import ConversationDetailMetaOptions from './conversation-detail-meta-options.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import TypeAssistant from '@/helpers/type-assistant'
import TimeAssistant from '@/helpers/time-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities, SpamTypes } from '@/types'
import { IAttachment } from '@/types/data-objects/attachments'
import {
  IChecklist,
  IConvosOutputHistoryv12,
  IItemReference,
  IJobAppointee,
  ILinkedItemForListing,
  IPersonWithEmail,
  IPriorityLevelForSelection,
  IStatusForSelection,
} from '@/api/types/response.types'
import { IJobAppointeeMap, IJobInfo } from '@/types/data-objects/items'

/* API */
import ConversationsAPI from '@/api/modules/convos.api'

enum RelatedTaskTypes {
  Checklists = 0,
  Tasks = 1,
  Conversations = 2,
}

export default Vue.extend({
  name: 'ConversationDetailHeader',

  components: {
    ConversationDetailLoading,
    ConversationDetailMetaOptions,
    ConversationDetailHeaderMessage,
  },

  props: {
    mailboxName: {
      type: String,
      required: true,
    },

    statusOptions: {
      type: Array as () => IStatusForSelection[],
      required: true,
    },

    priorityOptions: {
      type: Array as () => IPriorityLevelForSelection[],
      required: true,
    },

    assigneesOptions: {
      type: Array as () => IPersonWithEmail[],
      required: true,
    },

    tagsOptions: {
      type: Array as () => Array<String>,
      required: true,
    },

    checklists: {
      type: Array as () => IChecklist[],
      default: (): IChecklist[] => [],
    },

    linkedTasks: {
      type: Array as () => ILinkedItemForListing[],
      required: true,
    },

    otherConversations: {
      type: Array as () => ILinkedItemForListing[],
      required: true,
    },

    jobInfo: {
      type: Object as () => IJobInfo,
      default: null,
    },

    globalAttachments: {
      type: Array as () => IAttachment[],
      required: true,
    },

    refNumber: {
      type: Number,
      required: true,
    },

    creationDate: {
      type: [Date, String],
      required: true,
    },

    dueDate: {
      type: [Date, String],
      default: null,
    },

    customer: {
      type: Object as () => IPersonWithEmail,
      required: true,
    },

    assigneeID: {
      type: Number,
      default: null,
    },

    priorityID: {
      type: Number,
      required: true,
    },

    statusID: {
      type: Number,
      required: true,
    },

    subject: {
      type: String,
      required: true,
    },

    listTags: {
      type: Array as () => Array<String>,
      default: (): Array<String> => [],
    },

    showHarvestOption: {
      type: Boolean,
      required: true,
    },

    isDataLoading: {
      type: Boolean,
      default: false,
    },

    isPinned: {
      type: Boolean,
      required: true,
    },

    isTogglingSpam: {
      type: Boolean,
      default: false,
    },

    spamType: {
      type: Number,
      default: SpamTypes.NOT_SPAM,
    },

    creationEvent: {
      type: Object as () => IConvosOutputHistoryv12,
      required: true,
    },
  },

  data() {
    return {
      EEntities,
      ColorAssistant,
      TimeAssistant,
      SpamTypes,
      RouteAssistant,
      internalSubject: '',

      // UI controls
      subjectIsFocus: false,
      showModalHarvest: false,
      isUpdatingSubject: false,
      tabletMobilePickerSize: 'medium',
      selectedTaskType: RelatedTaskTypes.Tasks,

      // Checklists drawer
      showChecklistsDrawer: false,
      originatingChecklist: null as IChecklist,

      // Link tasks drawer
      showLinkTasksDrawer: false,
      originatingEventID: null,

      // Task detail drawer
      showTaskDetailDrawer: false,
      selectedLinkedTask: {} as ILinkedItemForListing,

      // Convo detail drawer
      showConversationDetailDrawer: false,
      selectedOtherConversation: {} as ILinkedItemForListing,

      // Used to display previous/next links on drawers...
      nextLinkedItem: {} as ILinkedItemForListing,
      prevLinkedItem: {} as ILinkedItemForListing,

      // Job appointee data
      jobAppointeeMaps: [] as IJobAppointeeMap[],
      // Store to check differences on watching jobAppointeeMaps[i]
      // since old array is not tracked on inner mutations...
      previousJobAppointeeMaps: [] as IJobAppointeeMap[],
    }
  },

  computed: {
    conversationForLinking(): IItemReference {
      return {
        id: this.conversationID,
        title: this.subject,
        refNumber: this.refNumber,
      } as IItemReference
    },
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
    conversationID(): number {
      return Number(this.$route.params.childId)
    },
    hasOtherConversations(): boolean {
      return this.otherConversations.length > 0
    },
    otherConversationsButtonLabel(): string {
      return (
        'Other Conversations by Customer (' +
        this.otherConversations.length +
        ')'
      )
    },
    checklistsButtonLabel(): string {
      return (
        'Checklists (' +
        this.checklists.reduce(
          (p, c) =>
            p +
            (c.checklistItems || []).reduce(
              (p2, c2) => p2 + (c2.isDone ? 1 : 0),
              0,
            ),
          0,
        ) +
        '/' +
        this.checklists.reduce(
          (p, c) => p + (c.checklistItems || []).length,
          0,
        ) +
        ')'
      )
    },
    linkedTasksButtonLabel(): string {
      return 'Linked Tasks (' + this.linkedTasks.length + ')'
    },
    hasSelectedTags(): boolean {
      return this.listTags.length > 0
    },
    hasJobs(): boolean {
      return this.jobInfo !== null
    },
    internalStatusID: {
      get(): any {
        return this.statusID
      },
      set(newValue: any) {
        if (this.statusID !== newValue) {
          this.$emit('update-status', newValue)
        }
      },
    },

    internalPriorityID: {
      get(): any {
        return this.priorityID
      },
      set(newValue: any) {
        if (this.priorityID !== newValue) {
          this.$emit('update-priority', newValue)
        }
      },
    },

    internalDueDate: {
      get(): any {
        return this.dueDate
      },
      set(newValue: any) {
        if (this.dueDate !== newValue) {
          this.$emit('update-dueDate', newValue)
        }
      },
    },

    internalAssigneeID: {
      get(): any {
        return this.assigneeID
      },
      set(newValue: any) {
        if (this.assigneeID !== newValue) {
          this.$emit('update-assignee', newValue)
        }
      },
    },

    internalListTags: {
      get(): any {
        return this.listTags
      },
      set(newValue: any) {
        this.$emit('update-tags', newValue)
      },
    },

    isSpam(): boolean {
      return TypeAssistant.isSpam(this.spamType)
    },
  },

  watch: {
    '$store.state.app.itemEventForLinkedTaskID': {
      handler(val) {
        if (val !== null) {
          this.openLinkTasksDrawer(val)
          this.$store.set('app/itemEventForLinkedTaskID', null)
        }
      },
    },

    subject: {
      immediate: true,
      handler(newVal: string) {
        this.internalSubject = newVal
        this.isUpdatingSubject = false
      },
    },

    'jobInfo.jobAppointees': {
      immediate: true,
      handler(newVal: IJobAppointee[]) {
        if (!newVal) {
          return
        }
        newVal.forEach(j => {
          this.jobAppointeeMaps.push({
            jobID: j.job.id,
            appointeeID: j.appointee !== null ? j.appointee.id : null,
          })
        })
        this.previousJobAppointeeMaps = cloneDeep(this.jobAppointeeMaps)
      },
    },

    jobAppointeeMaps: {
      async handler(newJobAppointeeMaps) {
        for (let i = 0; i < newJobAppointeeMaps.length; i++) {
          if (
            newJobAppointeeMaps[i].appointeeID !==
            this.previousJobAppointeeMaps[i].appointeeID
          ) {
            this.$emit(
              'update-job-appointee',
              newJobAppointeeMaps[i].jobID,
              newJobAppointeeMaps[i].appointeeID,
            )
          }
        }
        this.previousJobAppointeeMaps = cloneDeep(newJobAppointeeMaps)
      },
      deep: true,
    },

    checklists: {
      immediate: true,
      handler() {
        if (this.checklists.length > 0) {
          this.selectedTaskType = RelatedTaskTypes.Checklists
        }
      },
    },
  },

  methods: {
    handleOtherConversationsClicked() {
      this.selectedTaskType = 2
      document
        .getElementById('relatedItemsDiv')
        .scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    selectLinkedTask(taskID: number) {
      const itemIndex = this.linkedTasks.map(i => i.id).indexOf(taskID)
      this.selectedLinkedTask = this.linkedTasks[itemIndex]
      this.setNextPrevLinkedItems(this.linkedTasks, itemIndex)
      this.showTaskDetailDrawer = true
    },

    selectOtherConversation(conversationID: number) {
      const itemIndex = this.otherConversations
        .map(i => i.id)
        .indexOf(conversationID)
      this.selectedOtherConversation = this.otherConversations[itemIndex]
      this.setNextPrevLinkedItems(this.otherConversations, itemIndex)
      this.showConversationDetailDrawer = true
    },

    isJobAppointeeAssigned(jobAppointee: IJobAppointee): boolean {
      const mandate = this.jobInfo.assigneeMandates.find(
        am => am.statusID === this.statusID,
      )
      if (mandate) {
        const jobIDMandated = mandate.jobID

        if (jobAppointee.job.id !== jobIDMandated) {
          return false
        } else {
          if (
            (this.assigneeID === null && jobAppointee.appointee === null) ||
            (jobAppointee.appointee !== null &&
              this.assigneeID === jobAppointee.appointee.id)
          ) {
            return true
          }
        }
      }

      return false
    },

    // Ensures the job appointee is part of the list of options
    // (since we are simply pulling from the list of available assignees
    // it's possible the current job appointee was removed from the project
    // and never updated.)
    // May want to pull back a separate thing from getting listAssignees since
    // that is all memberships + current assignee -- so may be weird to see that.
    // Or just leave it. kinda edge casy.
    assembleAppointeeOptions(appointee: IPersonWithEmail): IPersonWithEmail[] {
      if (
        appointee === null ||
        this.assigneesOptions.find(a => a.id === appointee.id)
      ) {
        return this.assigneesOptions
      }
      return [...this.assigneesOptions, appointee]
    },

    async unlinkSelectedLinkedTask() {
      try {
        const response = await ConversationsAPI.put_UnlinkTask(
          this.mailboxID,
          this.conversationID,
          this.selectedLinkedTask.id,
        )

        this.$messaging.showSuccess(response.message)

        this.$emit('linked-tasks-updated', false)
        this.showTaskDetailDrawer = false
      } catch (error) {
        this.$error.emit(error, true)
      }
    },

    async linkExistingTask(taskId: number) {
      try {
        const response = await ConversationsAPI.post_LinkExistingTasks(
          this.mailboxID,
          this.conversationID,
          [taskId],
        )

        this.$messaging.showSuccess(response.message)

        this.$emit('linked-tasks-updated', false)
      } catch (error) {
        this.$error.emit(error, true)
      }
    },

    async openChecklistsDrawer(checklist: IChecklist) {
      this.originatingChecklist = checklist
      this.showChecklistsDrawer = true
    },

    async openLinkTasksDrawer(originatingEventID: Number = null) {
      this.originatingEventID = originatingEventID
      this.showLinkTasksDrawer = true
    },

    async handleChecklistCreated(checklist: IChecklist) {
      this.checklists.push(checklist)
    },

    async handleChecklistDeleted(checklist: IChecklist) {
      this.checklists.splice(
        this.checklists.findIndex(i => i.id === checklist.id),
        1,
      )
    },

    // These are for the next/prev links on the drawer, not to be confused with the ones on the base header
    setNextPrevLinkedItems(
      linkedItems: ILinkedItemForListing[],
      itemIndex: number,
    ) {
      this.prevLinkedItem = null
      this.nextLinkedItem = null

      if (itemIndex > 0) {
        this.prevLinkedItem = linkedItems[itemIndex - 1]
      }

      if (itemIndex < linkedItems.length - 1) {
        this.nextLinkedItem = linkedItems[itemIndex + 1]
      }
    },

    handleToggleSpam() {
      this.$emit('toggle-spam')
    },

    updateSubject(newValue: string) {
      if (newValue.trim().length === 0) {
        this.internalSubject = this.subject
        return
      }
      if (this.subject !== newValue && !this.isUpdatingSubject) {
        this.isUpdatingSubject = true
        this.$emit('update-subject', newValue)
      }
    },
  },
})
